import React, { FC } from 'react';

import { Layout } from './Layout';
import { Message, MessageType } from './Message';
import messages from './messages';

export interface EmptySearchStateProps {
  message?: MessageType;
  searchString?: string;
}

export const EmptySearchState: FC<EmptySearchStateProps> = ({ message = 'search value', searchString = '' }) => {
  const text = searchString ? (
    <Message definedMessage={messages.emptySearch} values={{ searchString: `'${searchString}'` }} />
  ) : (
    <Message message={message} />
  );

  return <Layout nodes={[text]} />;
};
